export const ESTATE_MAINTAIN_PAGE_LIS = {
  name: '报修工单分页列表',
  api: '${ZUKER}/ma-tenant/maintain/page/list',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#3d4a6d9124d8bfc974d3bdde201bf45f',
};
export const ESTATE_MAINTAIN_DETAIL = {
  name: '报修工单详情',
  api: '${ZUKER}/ma-tenant/maintain/detail',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#e6fd80075ccd29f3764026d7d0d192e5',
};
export const ESTATE_MAINTAIN_ADD = {
  name: '报修工单添加',
  api: '${ZUKER}/ma-tenant/maintain/add',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#076eea6387c20e802aba27a5c77e500a',
};
export const ESTATE_MAINTAIN_REPAIR_LIST = {
  name: '查询报修类型列表',
  api: '${ZUKER}/ma-tenant/maintain/repair/type/list',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#45f02c6fd187dbcfa071e53d85f4d207',
};
export const ESTATE_MAINTAIN_BUSINESSENTITY_INFO = {
  name: '主体详情-拉取所属楼层',
  api: '${ZUKER}/ma-tenant/api/D/businessEntity/info',
  method: "get",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#8995d437b3ba85116db8acb599a9037d',
};
export const ESTATE_MAINTAIN_URGE = {
  name: '催办',
  api: '${ZUKER}/ma-tenant/maintain/urge',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#7268fedecdef05536e23c424c34215f2',
};
export const ESTATE_MAINTAIN_ASSIGN = {
  name: '指派维修人员',
  api: '${ZUKER}/ma-tenant/maintain/assign',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#7268fedecdef05536e23c424c34215f2',
};
export const ESTATE_ACCOUNT_LISTBYFUNCTIONID = {
  name: '根据功能项id查询账号（例如：维修/分配人员）',
  api: '${ZUKER}/ma-tenant/api/D/account/listByFunctionId',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#221fd658f289d76250b49b331d3cfdf5',
};
export const ESTATE_MAINTAIN_GOBACK = {
  name: '工单退回',
  api: '${ZUKER}/ma-tenant/maintain/goback',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#221fd658f289d76250b49b331d3cfdf5',
};
export const ESTATE_MAINTAIN_TRANSFER = {
  name: '工单转派',
  api: '${ZUKER}/ma-tenant/maintain/transfer',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#221fd658f289d76250b49b331d3cfdf5',
};
export const ESTATE_MAINTAIN_FEETYPELIST = {
  name: '获取费用类型列表',
  api: '${ZUKER}/ma-tenant/maintain/get/fee/type/list',
  method: "get",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#221fd658f289d76250b49b331d3cfdf5',
};
export const ESTATE_MAINTAIN_COMPLETE = {
  name: '工单维修完成',
  api: '${ZUKER}/ma-tenant/maintain/complete',
  method: "post",
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#d3d61a238402e848d07c499969a754f2',
};
export const ESTATE_MAINTAIN_FEEITEMLIST = {
  name: '获取费用项列表',
  api: '${ZUKER}/ma-tenant/maintain/get/fee/item/list',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#d3d61a238402e848d07c499969a754f2',
};

